var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('button',{class:_vm.isDisclaimer ? 'mdn-Footer-disclaimer-librasLink' : 'mdn-Menu-top-event',attrs:{"type":"button","title":"Assistente de Libras"},on:{"click":function($event){$event.preventDefault();return _vm.toggleLibras()}}},[_c('span',{staticClass:"mdn-Icon-libras mdn-Icon--sm",attrs:{"aria-hidden":"true"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }